export const badgeClasses = [
  'primary',
  'danger',
  'success',
  'info',
  'warning',
  'dark-turquoise',
  'crimson',
  'dark-magenta',
  'dark-orange',
  'medium-orchid',
  'deep-pink',
  'saddle-brown',
  'tomato',
  'dark',
  'steel-blue',
  'orange-red',
  'dark-orchid',
  'hot-pink',
]

// breadcrumb seperator
export const separator = {
  title: '',
  path: '',
  isActive: false,
  isSeparator: true,
}

export const perPageArr = [10, 20, 50, 100]

export const keysforDateFormatValue = {
  payment: [
    'createdDateTime',
    'paymentScheme.startDateTime',
    'paymentScheme.endDateTime',
    'paymentToken.createdDateTime',
    'paymentToken.activationDateTime',
    'paymentToken.expiryDateTime',
  ],
  transaction: ['createdAt', 'completedAt'],
  couponTransaction: [
    'createdDateTime',
    'couponScheme.creationStartDateTime',
    'couponScheme.creationEndDateTime',
    'couponScheme.redemptionEndDateTime',
    'couponToken.dateIssued',
    'couponToken.dateExpires',
    'couponToken.lastRedeemedOn',
  ],
  activities: ['createdAt', 'updatedAt'],
  properties: ['startDate', 'endDate'],
  logistics: [
    'createdDateTime',
    'deliveryDateTime',
    'checkinDateTime',
    'pickupDateTime',
    'returnDateTime',
    'dropOffDateTime',
  ],
  promotion: [
    'createdOn',
    'creationStartDateTime',
    'creationEndDateTime',
    'redemptionEndDateTime',
  ],
}
